'use strict';

var serverData = (typeof window !== "undefined" ? window.pbizServer : typeof global !== "undefined" ? global.pbizServer : null);
var triggerCustomEvent = require('trigger-custom-event');
var appDom = require('./app-dom');
var loader = require('./loader');
var breadcrumb = require('./breadcrumb');
var gallerySelect = require('./gallery-select');
var galleryList = require('./gallery-list');
var imageGrid = require('./image-grid');
var slideshow = require('./slideshow');
var mainNav = require('./main-nav');
var comments = require('./comments');
var download = require('./download');
var bulkDownloadForm = require('./bulk-download-form');
var favorites = require('./favorites');
var music = require('./music');
var social = require('./social');
var contactLogin = require('./contact-login');
var dataMgr = require('./data-mgr');
var musicDataMgr = require('./music-data-mgr');
var coverPage = require('./cover-page');
var applyCoupon = require('./apply-coupon');
var removeCoupon = require('./remove-coupon');
var cart = require('./cart');
var addToCart = require('./add-to-cart');
var sidePanel = require('./side-panel');
var sidePanelStatusMsg = require('./side-panel-status-msg');
var buyPanel = require('./buy-panel');
var prints = require('./prints');
var productDetail = require('./product-detail');
var productImages = require('./product-images');
var packageDetail = require('./package-detail');
var packageImages = require('./package-images');

var isCoverPage = function() {

	return serverData.isCoverPage;

};

var setupApp = function() {

	loader.init();
	breadcrumb.init();
	gallerySelect.init();
	galleryList.init();
	imageGrid.init();
	slideshow.init();
	mainNav.init();
	sidePanel.init();
	sidePanelStatusMsg.init();
	contactLogin.init();
	buyPanel.init();

	if (dataMgr.hasEcommerceEnabled()) {

		applyCoupon.init();
		removeCoupon.init();
		cart.init();
		addToCart.init();
		prints.init();
		productDetail.init();
		productImages.init();
		packageDetail.init();
		packageImages.init();

	}

	if (dataMgr.hasFavoritesEnabled()) {

		favorites.init();

	}

	if (dataMgr.hasSharingEnabled()) {

		social.init();

	}

	if (dataMgr.hasDownloadsEnabled()) {

		download.init();
		bulkDownloadForm.init();

	}

	if (dataMgr.hasCommentsEnabled()) {

		comments.init();

	}

	if (musicDataMgr.hasMusic()) {

		music.init();

	}

	triggerCustomEvent('app_ready');

};

var addEventHandlers = function() {

	// We can't kick off the app until window load because we need to manipulate
	// the history state and address bar url.
	appDom.window.on('load', function() {

		// data-mgr is a unique module, in that it is intended to serve as a
		// high level application utility module to handle data interaction.
		// This module needs to be inited before any other modules to ensure
		// it has priority in event handler stacks and can properly setup all
		// initial data.
		dataMgr.init();

		// Now that the page has loaded and the url/history stack have been properly
		// updated, we can setup the rest of the application.
		setupApp();

	});

};

var init = function() {

	if (isCoverPage()) {

		console.log('Event login init...');

		coverPage.init();

	} else {

		console.log('Proofing app init...');

		addEventHandlers();

		// Attempt to identify touch devices.
		if ('ontouchstart' in window) {

			appDom.app.addClass('app--touch');

		} else {

			appDom.app.addClass('app--no-touch');
		}

	}

};

init();

module.exports = {};
